import { ReactElement, useEffect } from 'react';
// import Sidebar from '../components/Sidebar';
import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import Toolbar from '../components/Toolbar/Toolbar';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setDocumentSearchType } from '@/lib/state/slices/ProjectStateSlice';
import { useAppSelector } from '@/lib/hooks';
import Navbar from '@/components/Navbar/Navbar';

export default function Page(props: { children: ReactElement }) {
  const { open, onToggle } = useDisclosure({ defaultOpen: true });
  const location = useLocation();
  const dispatch = useDispatch();
  const searchType = useAppSelector((state) => state.viewReducer.documents.search.type);
  useEffect(() => {
    if (/research/.test(location.pathname)) {
      if (!(searchType === 'EXACT' || searchType === 'CONTEXT'))
        dispatch(setDocumentSearchType('EXACT'));
    } else if (/graphs\/?$/.test(location.pathname)) {
      dispatch(setDocumentSearchType('GRAPH'));
    } else if (/saved_cases\/?$/.test(location.pathname)) {
      dispatch(setDocumentSearchType('FOLDER'));
    } else if (/(saved_cases\/.+$)|(graphs\/.+$)/.test(location.pathname)) {
      dispatch(setDocumentSearchType('DOCUMENT'));
    }
  }, [location.pathname, dispatch, searchType]);

  return (
    <Box
      backgroundColor="background"
      display="flex"
      flexDirection="row"
      height="100%"
      width="100%"
      overflow="hidden"
    >
      <Navbar isOpen={open} onToggle={onToggle} />
      <Stack direction="column" height="100%" gap={0} flex={4} width="100%" minW={0}>
        <Box flex={1} height="0px" minW={0} overflow="hidden">
          {props.children}
        </Box>
      </Stack>
      <Toolbar />
    </Box>
  );
}
